<template>
    <el-container>
        <el-header>
            <el-form @submit.native.prevent :inline="true" :model="fromExtend" ref="fromExtend" class="demo-form-inline">
                <td-permission :permissions="permissionsView">
                    <div slot="havePermission">
                        <el-form-item :label="$t('common.EXTENDNAME')">
                            <td-input placeholder="common.PLEASE_SELECT" v-model="fromExtend.sName"></td-input>
                        </el-form-item>
                    </div>
                </td-permission>
                <el-form-item class="paddingLeft10">
                    <td-button type="primary" :permissions="permissionsView" :loading="loading" @click.native="queryPageList()">{{ $t('common.QUERY') }}</td-button>
                    <td-button type="button" :permissions="permissionsAdd" @click.native="btnAddExtend">{{ $t('common.ADD_EXTEND') }}</td-button>
                    <td-button type="button" :permissions="permissionsAdd" @click.native="btnDeleteBatch">{{ $t('common.DELETE_BATCH') }}</td-button>
                </el-form-item>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :permissions="permissionsView"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                :hasMutiSelect="true"
                :hasLoading="loading"
                ref="listExtendInfo"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                rowKey="sId"
            ></td-table>
            <!-- 加载扩展信息dialog -->
            <dialog-ExtendInfo
                v-if="dialogExtendVisible"
                :isAddData="isAddData"
                :dialogExtendVisible="dialogExtendVisible"
                :curModule="this.fromExtend.sModuleId"
                :moudleData="moudleData"
                :sysFlg="this.sysFlg"
                :maxExtendOrder="maxExtendOrder"
                :editItem="editItem"
                :title="title"
                ref="addOrModifyInfo"
                @extendDialogClose="extendDialogClose"
                @submit="submit"
            ></dialog-ExtendInfo>
        </el-main>
    </el-container>
</template>

<script>
import dialogExtendInfo from './components/dialogExtendInfo.vue';
import resourceApi from './assets/api.js';
export default {
    // 初始化渲染
    components: {
        'dialog-ExtendInfo': dialogExtendInfo
    },
    created() {},
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.queryPageList(); // 进行页面初始化数据的加载
    },

    // 定义数据
    data() {
        return {
            moudleData: [],
            fromExtend: {
                sName: '',
                sElementFlg: '',
                iElementType: '',
                sOptionData: '',
                sRegex: '',
                sViewInfo: ''
            },
            permissionsAdd: ['extendInfo:add'],
            permissionsEdit: ['extendInfo:edit'],
            permissionsView: ['extendInfo:view'],
            permissionsDel: ['extendInfo:del'],
            roles: ['admin'],
            editItem: '',
            showDelBtn: true,
            dialogExtendVisible: false,
            tableData: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false, // 按钮是否为加载状态
            columns: [
                {
                    prop: 'sName',
                    label: this.$t('common.EXTENDNAME'),
                    showOverflowTooltip: true
                },
                {
                    prop: 'sViewName',
                    label: this.$t('extendCommon.SHOW_NAME'),
                    showOverflowTooltip: true
                },
                {
                    prop: 'sElementType',
                    label: this.$t('common.EXTENDTYPE'),
                    align: 'center',
                    render: (createElement, params) => {
                        let res = params.row.sElementType;
                        return createElement('div', res);
                    }
                },
                {
                    prop: 'sElementFlg',
                    label: this.$t('extendCommon.ELEMENTFLG'),
                    showOverflowTooltip: true
                },
                {
                    prop: 'sOptionData',
                    label: this.$t('common.EXTENDDATA'),
                    showOverflowTooltip: true
                },
                {
                    prop: 'sRegex',
                    showOverflowTooltip: true,
                    label: this.$t('extendCommon.RULES')
                },
                {
                    prop: 'sRegexInfo',
                    showOverflowTooltip: true,
                    label: this.$t('extendCommon.TIPS_INFO')
                },
                {
                    prop: '',
                    label: this.$t('common.OPERATE'),
                    tableWidth: '90',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsEdit, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnEdit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { permissions: this.permissionsDel, type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnDelete(params.row.sId);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.submit();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        queryPageList() {
            this.currentPage = 1;
            this.btnQuery();
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                isPage: true,
                sName: this.fromExtend.sName,
                currentPage: this.currentPage,
                pageSize: this.pageSize
            };
            resourceApi.listExtendElementInfo(JSON.stringify(param), response => {
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('extendManage/listExtendElementInfo', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },
        // 添加
        btnAddExtend() {
            this.title = this.$t('common.ADD') + this.$t('common.EXTEND'); // 标题
            this.isAddData = true;
            this.dialogExtendVisible = true;
        },
        // 编辑
        btnEdit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT') + this.$t('common.EXTEND');
            this.isAddData = false;
            this.dialogExtendVisible = true;
        },

        // 删除接口
        btnDelete(sId) {
            this.$confirm(this.$t('extendMessage.DELETE_EXTEND_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = [{ sId: sId }];
                    resourceApi.deleteExtendElementBatch(param, response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.message, type: 'error' });
                            this.$log.error('extendManage/deleteExtendElementBatch', response.data.message);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.refreshPage();
                    });
                })
                .catch(() => {
                    // this.$message.info(this.$t('common.ADD_FAIL'))
                    // this.$log.error('extendInfo/btnDelete---- Fail')
                });
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnQuery();
        },
        // 关闭页面
        extendDialogClose() {
            this.dialogExtendVisible = false;
        },
        // 批量删除
        btnDeleteBatch() {
            this.$log.info('btnDeleteBatch');
            let params = this.getSelects();
            if (!params.length) {
                this.$message({ showClose: true, message: this.$t('extendMessage.PLEASE_SELECT_EXTEND'), type: 'warning' });
                return;
            }
            this.$confirm(this.$t('extendMessage.DELETE_EXTEND_TIPS'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    resourceApi.deleteExtendElementBatch(JSON.stringify(params), response => {
                        if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('extendManager/deleteExtendElementBatch', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.OPERATION_SUCCESS'), type: 'success' });
                        this.queryPageList();
                    });
                })
                .catch(() => {});
        },
        // 获取级别主键
        getSelects() {
            let ids = this.$refs.listExtendInfo.getSelectAllRows();
            let content = [];
            for (let i = 0; i < ids.length; i++) {
                let temValue = ids[i];
                let select = { sId: temValue.sId };
                content.push(select);
            }
            return content;
        },
        // 刷新模块
        refreshPage() {
            this.queryPageList();
        }
    }
};
</script>
